export enum BranchStatus {
  ACTIVE = 1,
  INACTIVE = 3,
  DELETE = 0,
}

export const BranchStatusOptions = [
  {
    label: "Active",
    value: BranchStatus.ACTIVE,
  },
  {
    label: "Inactive",
    value: BranchStatus.INACTIVE,
  },
];
